import React from 'react';
import cn from 'classnames';

import makoLogo from 'client/assets/Header/mako-logo-new.svg';
// import makoLogo from 'client/assets/Header/makoLogo.svg';
import { isMobileOrTablet } from 'client/hooks/responsive';

import css from './Header.module.scss';

const Header = () => {
  const isMobile = isMobileOrTablet();

  return (
    <div className={cn(css.header, isMobile && css.mobile)}>
      <div className={css.title}>
        דירוג <img src={makoLogo} alt="" /> חופש
      </div>
      <div className={css.greenLine} />
    </div>
  );
};

export default Header;
